// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","root":"ImageUploader_root__1Ysm6","btn":"ImageUploader_btn__3_5Rc","selected":"ImageUploader_selected__1Ad1o"};